'use es6';

import isNumber from 'transmute/isNumber';
export const validateNumericId = id => {
  const numericId = parseInt(id, 10);
  return isNumber(numericId);
};